import type { CSSProperties } from 'react'
import { cn } from '../helpers/classnames'

function Skeleton({
  className,
  isLoading = true,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { isLoading?: boolean }) {
  const skeletonStyle = isLoading
    ? ({
        '--twui-skeleton-base':
          'var(--brand-skeleton-base, rgba(0, 0, 0, 0.03))',
        '--twui-skeleton-border': 'var(--brand-skeleton-border, transparent)',
        '--twui-skeleton-highlight':
          'var(--brand-skeleton-highlight, rgba(0, 0, 0, 0.02))',
        ...style,
      } as CSSProperties)
    : style

  return (
    <div
      className={cn(
        'rounded-2xl',
        {
          'relative overflow-hidden border border-[var(--twui-skeleton-border)] bg-[var(--twui-skeleton-base)]':
            isLoading,
          'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_3s_ease-in-out_infinite] before:bg-gradient-to-r before:from-transparent before:via-[var(--twui-skeleton-highlight)] before:to-transparent':
            isLoading,
        },
        className
      )}
      style={skeletonStyle}
      {...props}
    />
  )
}

export { Skeleton }
